/*
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';

/*
 * Evergreen browsers require these.
 */
import 'core-js/es/reflect';

/*
 * ngx-charts required polyfill ie11
 */
import 'core-js/es/array';

// This is a temporary workaround for #849, while upstream dragula still relies on global.
// Setup: (https://www.npmjs.com/package/ng2-dragula)
// Uncaught ReferenceError: global is not defined #849
// https://github.com/valor-software/ng2-dragula/issues/849
(window as any).global = window;
